export class GeolocationMonitoring {
    startingLocationDate?: string;
    endingLocationDate?: string;
    doi?: Doi;
    device?: Device;
    agencyBranch?: LocationInfo;
    supplyPoint?: LocationInfo;
    outcome?: Outcome;
}

export class Doi {
    doiId?: string;
    createDate?: string;
    acceptedDate?: string;
}

export class Device {
    OS?: string;
    latitude?: number;
    longitude?: number;
    accuracy?: number;
}

export class LocationInfo {
    latitude?: number;
    longitude?: number;
    province?: string;
    municipality?: string;
    street?: string;
}

export class Outcome {
    metersFarFromAgency?: number;
    metersFarFromSupplyPoint?: number;
    isAtOffice?: boolean;
    isOnSite?: boolean;
}
